
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect, useState } from 'react';
import { InferGetServerSidePropsType } from "next";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SiteLayout from "@/components/layout/site";
import ActiveFilter from '@/components/fasce/ActiveFilter';
import FilterMenu from '@/components/fasce/FilterMenu';
import BannerResult from '@/components/fasce/BannerResult';
import CardList from '@/components/fasce/CardList';
import CmpPagination from '@/components/ui/Pagination';
import Stack from '@mui/material/Stack';
import Hero from '@/components/fasce/Hero';
import { WPHeroHeight, WPHeroTextLightness } from '@/data/wp/operations/queries/fragments/fascia-hero-banner';
import Box from '@mui/material/Box';
import { PageType } from '@/utils/router';
import { getDefaultSortOrder, getServerSidePropsForProductByCategoryId } from '@/utils/slug';
import { getFilteredValuesByCategoryId } from '@/data/hcl/sdk/utils';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import placeholderCategory from '@/public/placeholder-category.svg';

const GenericCategoryPage = ({ data }: InferGetServerSidePropsType<typeof getServerSideProps>) => {

  const router = useRouter();
  const { t } = useTranslation('common');
  const [filteredValues, setFilteredValue] = useState(data);
  let emptyFacets: any = [];
  const [facets, setFacets] = useState(emptyFacets);
  const [categoryPage, setCategoryPage] = useState(1);
  const [orderBy, setOrderBy] = useState(getDefaultSortOrder());
  const [filterNames, setFilterNames] = useState(data?._filterNames);
  // const defaultLabel = t('order-by-default-val');
  const nameLabel = t('order-by-name-val');

  useEffect(() => {
    setFilteredValue(data);
    setFacets([]);
    setCategoryPage(1);
    setOrderBy(getDefaultSortOrder());
    setFilterNames(data?._filterNames);
  }, [router.query.slug, data]);

  const handleFilter = async (queryParams : any) => {
    console.log('handleFilter', queryParams);
    if (!queryParams.orderBy){
      setOrderBy(getDefaultSortOrder());
    }else{
      setOrderBy(queryParams.orderBy);
    }
    

    let facetList: any = [];
    let filterValue = queryParams.filterValue;
    if(facets.includes(filterValue)) {
      facetList = facets.filter((item : any) => item !== filterValue);
      setFacets(facetList);
    }else if(filterValue === null){
      facetList = [];
      setFacets([]);
    }else if(filterValue === undefined){
      facetList = facets;
    }else if(Array.isArray(filterValue)){
      let facetId = filterValue[0].split(':')[0];
      const facetListTmp = facets.filter((facet: string) => !facet.includes(facetId) );
      if(!queryParams.sliderFilterValueDeleted){
        facetList = [...facetListTmp, ...filterValue];
        setFacets([...facetListTmp, ...filterValue]);
      }else {
        let sliderFacetListTmp = facets.filter((x: string) => filterValue.indexOf(x.split(':')[1]?.replaceAll("\"", "")) === -1);
        facetList = sliderFacetListTmp;
        setFacets(sliderFacetListTmp);
      }
    } else {
      facetList = [...facets, filterValue];
      setFacets([...facets, filterValue]);
    }
    let params = router.query;
    queryParams.params = params;
    
    queryParams.facetList = facetList;
    queryParams.orderBy = queryParams.orderBy ? queryParams.orderBy : '1';
    queryParams.filterNames = filterNames;
    const { data } = await getFilteredValuesByCategoryId(queryParams);
    setFilteredValue(data);
    
    if(!queryParams.notResetPage) {
      setCategoryPage(parseInt(queryParams.pageNumber));
    }
  }

  const numOfCardListPerPage = 12;

  const handleChange = (page: any, orderBy: string, storeData: any) => {
    setCategoryPage(page);
    setOrderBy(orderBy);
    let queryParams = {
      storeId: storeData.storeId,
      langId: storeData.langId,
      catalogId: storeData.catalogId,
      locale: storeData.locale,
      categoryId: storeData.categoryId,
      orderBy: orderBy,
      pageNumber: page.toString(),
      pageSize: numOfCardListPerPage.toString(),
      notResetPage: true
    }
    handleFilter(queryParams);
  }

  const page = data?.pages?.nodes?.[0];

  return (
    <SiteLayout pageType={PageType.PLP} data={data} translations={page?.translations} seo={page?.seo} language={page?.language}>

      <Hero
        height={WPHeroHeight.small}
        slides={[
          {
            backgroundImage: {
              id: 'hero-image',
              mimeType: data?.categoryData?.fullImage ? 'image/jpeg': 'image/svg+xml',
              mediaItemUrl: data?.categoryData?.fullImage ? data?.categoryData?.fullImage : placeholderCategory,
              mediaDetails: { width: 1440, height: 267 }
            },
            textLightness: WPHeroTextLightness.dark,
            title: data?.categoryData?.name,
          },
        ]}
      />

      <Container sx={{paddingTop: '40px'}}>
        <Grid container sx={{ mb: '50px'}}>
          <Grid item xs={12} md={3}>

            <FilterMenu
              accordions={filteredValues?._facets}
              facets= {facets}
              dataModal={{
                btnOpenModal: t('btn-open-modal-filter'),
                title: t('modal-title-filter'),
                backButton: t('btn-back-modal-filter'),
                confirmButton: t('btn-confirm-modal-filter')
              }}
              storeData = {{
                storeId: data._products[0].storeId,
                langId: data.langId,
                catalogId: data.catalogId,
                locale: data.locale,
                orderBy: orderBy,
                categoryId : data._products[0].categoryId,
                pageNumber: '1',
                pageSize: numOfCardListPerPage.toString()
              }}
              handleFilter = {
                handleFilter
              }
            />

          </Grid>
          <Grid item xs={12} md={9}>

            <ActiveFilter
              title={t('active-filter-title')}
              chips={filteredValues?._activeFilters}
              storeData = {{
                storeId: data._products[0].storeId,
                langId: data.langId,
                catalogId: data.catalogId,
                locale: data.locale,
                orderBy: orderBy,
                categoryId : data._products[0].categoryId,
                pageNumber: '1',
                pageSize: numOfCardListPerPage.toString()
              }}
              handleFilter = {
                handleFilter
              }
              btnRemoveFilters={t('active-filter-remove-filter-btn')}
            />

            <BannerResult
              resultNumber={filteredValues?.recordSetTotal}
              orderList={[
                {
                  label: nameLabel,
                  value: '2'
                }
              ]}
              selectedOrderBy = {orderBy}
              storeData = {{
                storeId: data._products[0].storeId,
                langId: data.langId,
                catalogId: data.catalogId,
                locale: data.locale,
                orderBy: orderBy,
                categoryId : data._products[0].categoryId,
                pageNumber: '1',
                pageSize: numOfCardListPerPage.toString()
              }}
              handleFilter = {
                handleFilter
              }
            />

            <Box sx={{mx: { xs: '-16px', sm: '-24px'}}}>
              <CardList
                is3Col={true}
                whiteCardList={filteredValues?._products}
              />
            </Box>

            <Stack direction="row" sx={{ mb: '20px', padding: '0 16px' }}>
              <CmpPagination numOfPage={Math.ceil(filteredValues?.recordSetTotal / numOfCardListPerPage)} page={categoryPage} onChange={(_e,categoryPage) => handleChange(categoryPage, orderBy, {
                storeId: data._products[0].storeId,
                catalogId: data.catalogId,
                langId: data.langId,
                locale: data.locale,
                categoryId : data._products[0].categoryId
              })} />
            </Stack>
          </Grid>
        </Grid>
      </Container>


    </SiteLayout>
  );
};

export default GenericCategoryPage;

 const _getServerSideProps = getServerSidePropsForProductByCategoryId;



// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/cat/[brand]/[category]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  